<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p18"><span><a href="#/Contents#rp18">RICH MUSHROOM STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Dried shiitake mushrooms, also known as Chinese black mushrooms, add richness and depth of flavor to this stock.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>1 each: sliced large onion, leek (white part only), rib celery</span></p>
<p class="hang"><span>12 ounces cremini or white mushrooms</span></p>
<p class="hang"><span>1 tablespoon minced garlic</span></p>
<p class="hang"><span>1 teaspoon olive oil</span></p>
<p class="hang"><span>7 cups water</span></p>
<p class="hang"><span>¾ cup dry white wine or water</span></p>
<p class="hang"><span>1½–2 ounces dried shiitake mushrooms</span></p>
<p class="hang"><span>6 sprigs parsley</span></p>
<p class="hang"><span>¾ teaspoon each: dried sage and thyme leaves</span></p>
<p class="hang"><span>1½ teaspoons black peppercorns</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion, leek, celery, cremini mushrooms, and garlic in oil in Dutch oven 5 minutes; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 1½ hours. Strain, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 27</span></p>
<p class="per1"><span>% calories from fat: 22</span></p>
<p class="per1"><span>Protein (g): 0.4</span></p>
<p class="per1"><span>Carbohydrate (g): 1.6</span></p>
<p class="per1"><span>Fat (g): 0.7</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 9</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0118.vue?52dcce92